import { Company } from './styled';
import { RouterLink } from '@redux-first-router-link';
import { Column } from '@simplywallst/ui-core';
import track, { useTracking } from 'react-tracking';
import loadable from '@loadable/component';

const WatchlistAddRemoveCompanyToggle = loadable(
  () => import('@/components/WatchlistAddRemoveCompanyToggle')
);

interface Props {
  companyId: string;
  canonicalUrl: string;
  tickerSymbol: string;
  companyName: string;
  uniqueSymbol: string;
  index: number;
}

const FollowItem = ({
  companyId,
  canonicalUrl,
  tickerSymbol,
  companyName,
  uniqueSymbol,
  index,
}: Props) => {
  const { trackEvent } = useTracking();
  return (
    <Company as="li" data-cy-id="dashboard-follow-item" noWrap>
      <Column width="auto" fillVoid>
        <RouterLink
          to={canonicalUrl}
          noUnderline
          onClick={() =>
            trackEvent({
              action: 'click',
              modifier: 'tickerSymbol',
              index,
              companyId,
              uniqueSymbol: uniqueSymbol,
            })
          }
        >
          <h3 data-cy-id="dashboard-follow-ticker">{tickerSymbol}</h3>
          <p data-cy-id="dashboard-follow-name">{companyName}</p>
        </RouterLink>
      </Column>
      <Column width="auto" alignSelf="center">
        <WatchlistAddRemoveCompanyToggle
          companyId={companyId}
          tickerSymbol={tickerSymbol}
          styleType="gentle"
        />
      </Column>
    </Company>
  );
};

export default track({
  type: 'track',
})(FollowItem) as typeof FollowItem;
